<template>
    <div
        class="footer-add-button flex"
        :class="{
            'bottom-btn': isHabitation,
            'safe-area-inset-bottom': safeAreaInset
        }"
    >
        <van-button
            @click="config"
            class="btn font-bold"
            :loading="btnLoading"
            loading-type="circular"
            :loading-text="loadingText"
        >
            <slot name="content" v-if="!btnText"> </slot>
            <div class="btn-text font-34 btn" v-else>{{ btnText }}</div>
        </van-button>
    </div>
</template>

<script>
export default {
    props: {
        isHabitation: {
            // 是否是居于底部的按钮
            type: Boolean,
            default: true
        },
        btnText: {
            // 显示按钮的文案
            type: String,
            default: ''
        },
        btnLoading: {
            // 是否需要加载中
            type: Boolean,
            default: false
        },
        loadingText: {
            // 加载中文案
            type: String,
            default: '加载中...'
        }
    },
    data() {
        return {}
    },
    methods: {
        /**
         * 确定事件
         */
        config() {
            this.$emit('config')
        }
    }
}
</script>

<style scoped lang="scss">
.footer-add-button {
    background-color: #ffffff;
    width: 100vw;
    padding: 20px 0;
    .btn {
        border-radius: 40px;
        flex: 1;
        margin: 0 30px;
        background-color: #5277fd;
        color: #ffffff;
    }
}
.bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
}
</style>
